module.exports = __webpack_public_path__ + "static/media/Quote-logo1.89eb6c24.png";